// ** React Imports
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Store & Actions
import { useDispatch, useSelector } from "react-redux";

// ** Third Party Components
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { User, Power } from "react-feather";

// ** Default Avatar Image
import {
  getUser,
  isClient,
  isCandidate,
  isConsultant,
  isManager,
} from "@services/authentificationServices";
import { getUserDetails } from "@store/profile/actionCreator";
import AlertModalSecurity from "@components/modal-popup/index";
import { useTranslation } from "react-i18next";
import { getInitials } from "@src/utility/data/convertedData";
import { STRINGS } from "../../../../utility/_helpers/strings";

const UserDropdown = () => {
  // ** Store Vars
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.profile.user);

  // ** State
  const [userData, setUserData] = useState(userInfo);
  const [modal, setModal] = useState(false);

  let initilas;

  if (userData && isCandidate()) {
    initilas = getInitials(`${userData?.first_name} ${userData?.last_name}`);
  } else if (userData) {
    initilas = getInitials(`${userData?.firstName} ${userData?.lastName}`);
  } else {
    initilas = STRINGS.TEXTS.EMPTY_TEXT;
  }

  //** ComponentDidMount
  useEffect(() => {
    if (isCandidate()) dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (isCandidate()) {
      if (userInfo) {
        setUserData(userInfo.data);
      }
    } else {
      setUserData(getUser());
    }
  }, [userInfo]);

  //** Vars
  const userAvatar =
    userData && userData.image_profile ? userData.image_profile : null;

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name font-weight-normal">
            {isCandidate()
              ? userData && userData.first_name
                ? userData.first_name + " " + userData && userData.last_name
                  ? userData.last_name
                  : ""
                : STRINGS.TEXTS.EMPTY_TEXT
              : userData && userData.firstName
              ? userData.firstName + " " + userData && userData.lastName
                ? userData.lastName
                : ""
              : STRINGS.TEXTS.EMPTY_TEXT}
          </span>
          <span className="user-status text-muted font-weight-normal">
            {isCandidate()
              ? t("candidate")
              : isClient()
              ? t("client")
              : isConsultant()
              ? t("consultant")
              : isManager()
              ? t("manager")
              : "Admin"}
          </span>
        </div>
        <Avatar
          img={userAvatar}
          userDefaultAvatar={userData && initilas}
          imgHeight="40"
          imgWidth="40"
          status="online"
        />
      </DropdownToggle>
      <DropdownMenu right>
        {isCandidate() && (
          <DropdownItem tag={Link} to="/profil">
            <User size={14} className="mr-75" />
            <span className="align-middle">{t("profile")}</span>
          </DropdownItem>
        )}
        <DropdownItem
          tag={Link}
          to="/login"
          onClick={(e) => {
            e.preventDefault();
            setModal(true);
          }}
        >
          <Power size={14} className="mr-75" />
          <span className="align-middle">{t("nav_disconnection")}</span>
        </DropdownItem>
      </DropdownMenu>
      <AlertModalSecurity
        modal={modal}
        setModal={setModal}
      ></AlertModalSecurity>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
